// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"c2d00e4d","110":"1345062f","140":"3154fbf0","619":"50ddb3cd","624":"00aca8e2","784":"78c8f0d3","841":"f6a41c07"}[chunkId] + ".chunk.css";
};